import { TextProps, TextPropsOptions } from '@features/powerpoint';
import { contentSlideTitleText } from '../../../../slides/content-slide-title-text';
import { colorByIndex } from '../audience-profile/color-by-index';
import { DemographicProfileChartConfiguration } from '../demographic-profile';

const textOptionsConfig = [
  {
    w: 2.11,
    x: 1.12,
    y: 1.89,
  },
  {
    w: 2.11,
    x: 4.16,
    y: 1.89,
  },
  {
    w: 2.11,
    x: 7.17,
    y: 1.89,
  },
  {
    w: 2.11,
    x: 10.19,
    y: 1.89,
  },
  {
    w: 2.11,
    x: 1.12,
    y: 4.01,
  },
  {
    w: 2.11,
    x: 4.16,
    y: 4.01,
  },
  {
    w: 2.11,
    x: 7.17,
    y: 4.01,
  },
  {
    w: 2.11,
    x: 10.19,
    y: 4.01,
  },
] as const satisfies readonly TextPropsOptions[];

type TextsOptions = {
  chartConfig: DemographicProfileChartConfiguration;
};

export const texts = (charts: TextsOptions): TextProps[] => [
  contentSlideTitleText(
    '<lci>Demographic</lci> <b>Profile (Saw the Ad & Visited)</b>'
  ),
  ...charts.chartConfig.map((profile, chartIndex): TextProps => {
    const textOptions = textOptionsConfig[chartIndex];

    if (!textOptions) {
      throw new Error('Text options are undefined');
    }

    return {
      text: profile.title.toUpperCase(),
      options: {
        ...textOptions,
        fontSize: 10,
        color: colorByIndex(chartIndex),
        align: 'center',
        h: 0.27,
        x: textOptions.x,
      },
    };
  }),
];
